/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChildOrderItem } from './childOrderItem.js';
import { OrderItemUnit } from './orderItemUnit.js';


export interface OrderItem { 
    /**
     * Order item id, unique within an order.
     */
    orderItemId: string;
    /**
     * GUID of the online model. SFDC: Online_Model__c.GUID__c.
     */
    onlineModelCode: string;
    /**
     * GUID of the commercial product. SFDC: cspmb__Price_Item__c.GUID__c into Online_Order_Item__c.Price_Item_Id__c.
     */
    commercialProductCode: string;
    /**
     * GUIDs of the addiotional commercial products, mostly for sales products. SFDC: cspmb__Price_Item__c.GUID__c into Online_Order_Item__c.Price_Item_Id__c.
     */
    additionalCommercialProductCodes?: Array<string>;
    /**
     * GUID of the Campaign Association applied to this commercial product.
     */
    campaignAssociationCode?: string;
    /**
     * GUID of the offer being ordered. SFDC: SFDC: cscfga__Configuration_Offer__c.csexpimp1__guid__c
     */
    offerCode: string;
    /**
     * Quantity
     */
    quantity: number;
    /**
     * Source of the item, where it was put in the basket, either OMAELISA or PUBLIC_PAGE
     */
    source: OrderItem.SourceEnum;
    /**
     * Frame agreement id under which the customer level prices of commercial products and addons are defined
     */
    customerLevelPricesId?: string;
    /**
     * Customer level discount contract Id on given commercial products and addons
     */
    customerLevelDiscountsId?: string;
    /**
     * Set to true when enrollment program is selected otherwise set to false
     */
    enrollmentProgramSelected?: boolean;
    /**
     * Customer\'s Device Enrollment Alias, It\'s free text provided by user for KME enrollment.
     */
    enrollmentProgramAlias?: string;
    /**
     * Internal, unique id of the old subscription for which the device change order has been placed. This id is only present in case of device change orders. SFDC: csord__Subscription__c.Id
     */
    replacedSubscriptionId?: string;
    /**
     * Details about each individual unit within this order item
     */
    orderItemUnits?: Array<OrderItemUnit>;
    /**
     * List of child order items.
     */
    childOrderItems?: Array<ChildOrderItem>;
}
export namespace OrderItem {
    export type SourceEnum = 'OMAELISA' | 'PUBLIC_PAGE';
    export const SourceEnum = {
        OMAELISA: 'OMAELISA' as SourceEnum,
        PUBLIC_PAGE: 'PUBLIC_PAGE' as SourceEnum
    };
}


